import * as actionTypes from "../../Action/actionTypes";
import React from "react";

const initialState = {
  guestUser:{
    guestIsLogin:null,branchId:null,guestStatus:null,pinRequired: false
  },
  guestBranchName: '',

  guestQRIsCovidDetails: false,
  guestQRCovidObj: null,
  guestCurrentCorporateId: 0,
  guestIsAvailable: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {


    case actionTypes.GUEST_USER_VALIDATION:
      return {
        ...state,
        guestUser: action.value
      };
    case actionTypes.GUEST_BRANCH_NAME:
      return {
        ...state,
        guestBranchName: action.value
      };
    case actionTypes.GUEST_QR_HR_COVID_RESULT:
      return {
        ...state,
        // guestBranchName: action.value,
        guestQRIsCovidDetails: action.value.guestQRIsCovidDetails,
        guestQRCovidObj: action.value.guestQRCovidObj
      };
    case actionTypes.GUEST_CURRENT_CORPORATE_ID:
      return {
        ...state,
        guestCurrentCorporateId: action.value.guestCurrentCorporateId,
        guestIsAvailable: action.value.guestIsAvailable
      };

    default:
      return state;
  }
};

export default reducer;
